import { useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { isDemoMode } from "../utils/demoApiInterceptor";

const useLangNavigate = () => {
  const navigate = useNavigate();
  const { i18n } = useTranslation();

  const navigateWithLang = useCallback(
    (to, { newTab = false, ...options } = {}) => {
      const lang = i18n.language.split("-")[0];
      const isDemo = isDemoMode();
      let newPath = "";

      if (typeof to === "string") {
        newPath = to.startsWith("/") ? `/${lang}${to}` : `/${lang}/${to}`;
        // If in demo mode and navigating to dashboard routes, prepend /demo
        if (isDemo && newPath.includes("/dashboard/")) {
          newPath = newPath.replace(`/${lang}/dashboard/`, `/${lang}/demo/dashboard/`);
        }
      } else if (typeof to === "object" && to.pathname) {
        newPath = `/${lang}${
          to.pathname.startsWith("/") ? to.pathname : "/" + to.pathname
        }`;
        // If in demo mode and navigating to dashboard routes, prepend /demo
        if (isDemo && newPath.includes("/dashboard/")) {
          newPath = newPath.replace(`/${lang}/dashboard/`, `/${lang}/demo/dashboard/`);
        }
        to = { ...to, pathname: newPath };
      } else {
        newPath = to;
      }

      newTab ? window.open(newPath, "_blank") : navigate(newPath, options);
    },
    [navigate, i18n]
  );

  return navigateWithLang;
};

export default useLangNavigate;
